<div class="w-full flex justify-center items-center text-slate-400 my-8">
  <div class="text-center max-w-[300px] m-auto">
    <h1 class="font-bold">Welcome to the Planner</h1>
    <p>
      Here you can create Tags and assign them Colors, Summary types and Planned
      amounts. To get started:
    </p>
    <ul class="mt-4">
      <li class="underline cursor-pointer" (click)="addTag.emit()">
        Create a Tag
      </li>
    </ul>
  </div>
</div>
